import { AbstractControl } from '@angular/forms';

export function ValidateUri(control: AbstractControl) {
	const results = control.value?.match(/[[a-zA-Z]:[\\/](?:[a-zA-Z\d]+[\\/])*([a-zA-Z\d])/);
	if (typeof control?.value === 'string' && !results) {
		return { invalidUri: true };
	}
	return null;
}
